<template>
  <div id="app">
    <TheHeader />
    <main id="main">
      <NewsletterPopup />
      <FloatingWhatsapp phone="5588997910019" />
      <transition mode="out-in">
        <router-view />
      </transition>
    </main>
    <TheFooter />
  </div>
</template>

<script>
import TheHeader from "./components/TheHeader.vue";
import TheFooter from "./components/TheFooter.vue";
import NewsletterPopup from "./components/NewsletterPopup.vue";
import FloatingWhatsapp from "@/components/FloatingWhatsapp.vue";

export default {
  components: {
    TheHeader,
    TheFooter,
    NewsletterPopup,
    FloatingWhatsapp,
  },
  watch: {
    $route() {
      const el = document.querySelector(".main-scroll") || window;
      el.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap");

/* Font born */
@font-face {
  font-family: "Born";
  src: url("@/assets/fonts/Born.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Container com 1200px Width */
.container-egp {
  max-width: 1200px;
  margin: 0 auto;
  padding: 110px 0;
}

@media (max-width: 640px) {
  .container-egp {
    padding: 65px 15px;
  }
  .titulo-mobile {
    font-size: 2rem !important;
    text-align: center;
    margin-bottom: 12px;
  }
  img {
    max-width: 100%;
  }
  .logo-egroup {
    max-width: 112px;
  }
}

/* Container com 1360px Width */
.container-egp-lg {
  width: 1360px;
  margin: 0 auto;
  border-radius: 6px;
}

ul {
  list-style: none;
}

body {
  font-family: "Nunito", sans-serif;
  color: #345;
  background: #fcfcfc;
}

a {
  color: #345;
  text-decoration: none;
}

img {
  max-width: 100%;
  display: block;
}

h1 {
  font-size: 42px !important;
  color: #123050 !important;
  font-family: "Nunito", sans-serif !important;
  font-weight: 700 !important;
  line-height: 50px;
  font-family: "Born", sans-serif !important;
}

h2,
h3,
h4,
h5,
h6 {
  font-family: "Born", sans-serif !important;
}

p {
  font-size: 1.2rem;
  color: #345e89;
  margin-top: 16px;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  max-width: max-content;
  padding: 6px 16px;
  border-radius: 100px;
  text-align: center;
  font-size: 1rem;
  font-weight: 700 !important;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  transition: all 0.3s;
  border: 1px solid #5782ae;
  color: #123050;
  font-family: "Nunito", sans-serif;
  cursor: pointer;
}

.btn:hover {
  transform: scale(1.05);
}

@media screen and (max-width: 640px) {
  .btn {
    min-width: fit-content;
  }
  .btn img {
    max-width: 24px;
  }
}

#app {
  display: flex;
  margin: 0 auto;
  flex-direction: column;
}

#main {
  flex: 1;
}

label {
  margin-bottom: 6px;
}

/* input:not([type='checkbox']),
textarea {
  border-radius: 4px;
  border: 1px solid #fff;
  padding: 25px;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.1);
  transition: all;
  font-size: 1rem;
  font-family: 'Avenir', Helvetica, Arial sans-serif;
  margin-bottom: 15px;
  width: 100%;
}

input:not([type='checkbox']):hover,
input:not([type='checkbox']):focus,
textarea:hover,
textarea:focus {
  outline: none;
  box-shadow: 0 6px 12px rgba(30, 60, 90, 0.2);
  border-color: #87f;
} */

.v-enter,
.v-leave-to {
  opacity: 0;
}

.v-enter {
  transform: translate3d(0, -20px, 0);
}

.v-leave-to {
  transform: translate3d(0, 20px, 0);
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

.btn-disabled,
.btn-disabled:hover {
  background: #bbc;
  transform: scale(1);
}

/* link */
.visit-link {
  display: inline-flex; /* mantém o conteúdo alinhado igual ao flex do Tailwind */
  align-items: center;
  gap: 0.5rem; /* ajusta o espaçamento entre texto e ícone */
  cursor: pointer;
  text-decoration: none;
}

/* ícone */
.visit-icon {
  display: inline-block; /* necessário para transform funcionar direitinho */
  transform: translateX(0);
  transition: transform 0.28s cubic-bezier(0.2, 0.9, 0.2, 1);
  will-change: transform;
}

/* hover/focus - move a seta para a direita (8px) */
.visit-link:hover .visit-icon,
.visit-link:focus .visit-icon {
  transform: translateX(8px);
}

/* acessibilidade: reduz animação se usuário preferir menos movimento */
@media (prefers-reduced-motion: reduce) {
  .visit-icon {
    transition: none !important;
  }
}

/* Scale de passar mouse em cima */
.scale-egp:hover {
  transform: scale(1.05);
  transition: all 0.3s;
}

.font-born {
  font-family: "Born", sans-serif !important;
}

/* Overlay */
.overlay {
  background: rgba(30, 60, 90, 0.2);
}
</style>
